const serviceList = [
  {
    id: 1,
    title: "专利分析",
  },
  {
    id: 2,
    title: "专利查新",
  },
  {
    id: 3,
    title: "分级分类",
  },
  {
    id: 4,
    title: "素养教育",
  },
];

const analysisList = [
  {
    id: 1,
    title: "壹专利",
  },
  // {
  //   id: 2,
  //   title: "Innography",
  // },
  {
    id: 3,
    title: "大为",
  },
];

module.exports = {
  serviceList,
  analysisList,
};
